/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

export interface ICheckoutCurrentAccordionStepState {
    currentStep?: number;
}

export class CheckoutAccordionStateInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `checkoutAccordionStepsState`;
    public getCacheObjectType = () => 'checkoutAccordionStepsState';
    public dataCacheType = (): CacheType => 'none';
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new CheckoutAccordionStateInput();
};

export async function getCheckoutCurrentAccordionStepAction(
    input: CheckoutAccordionStateInput,
    ctx: IActionContext
): Promise<ICheckoutCurrentAccordionStepState> {
    return { currentStep: undefined };
}

export default createObservableDataAction<ICheckoutCurrentAccordionStepState>({
    action: <IAction<ICheckoutCurrentAccordionStepState>>getCheckoutCurrentAccordionStepAction,
    input: createInput
});
